import { fork } from 'redux-saga/effects';

import loadData from './initialDataSaga';
import authSaga from './authSaga';
import getStreamNameSaga from './getStreamNameSaga';
import getTimelineSaga from "./getTimelineSaga";
import cancelAllRequestsSaga from "./cancelAllRequestsSaga";
import ptzSaga from "./ptzSaga";
// import getBrowseFrameSaga from "./getBrowseFrameSaga";
import startBrowsemodeSaga from "./startBrowsemodeSaga";
import gotoBrowseFrameSaga from "./gotoBrowseFrameSaga";
import runPlaybackSaga from "./runPlaybackSaga";
import exportFilesSaga from "./exportFilesSaga";
import getAvilistSaga from "./getAviListSaga";
import heartbeatenSaga from "./heartbeatenSaga";
import getBookmarksSaga from "./getBookmarksSaga";
import startBookmarkSaga from "./startBookmarkSaga";
import deleteBookmarkSaga from "./deleteBookmarkSaga";
import getBookmarksInfoSaga from './getBkmInfoSaga';
import pollEventsSaga from './pollEventsSaga';
import getEventsInfo from './getEventsInfo';
import acknowledgeSaga from './acknowledgeSaga';
import triggersSaga from './triggersSaga';
import addCaseSaga from './addCaseSaga';
import getLayoutInfo from './getLayoutInfoSaga';


// TODO
// Rewrite sagas to TS

export default function* rootSaga() {
    yield fork(loadData);
    yield fork(authSaga);
    yield fork(getStreamNameSaga);
    yield fork(getTimelineSaga);
    // yield fork(getBrowseFrameSaga);
    yield fork(startBrowsemodeSaga);
    yield fork(gotoBrowseFrameSaga);
    yield fork(runPlaybackSaga);
    yield fork(exportFilesSaga);
    yield fork(getAvilistSaga);
    yield fork(heartbeatenSaga);
    yield fork(getBookmarksSaga);
    yield fork(startBookmarkSaga);
    yield fork(deleteBookmarkSaga);
    yield fork(getBookmarksInfoSaga);
    yield fork(pollEventsSaga);
    yield fork(cancelAllRequestsSaga);
    yield fork(getEventsInfo);
    yield fork(acknowledgeSaga);
    yield fork(ptzSaga);
    yield fork(triggersSaga);
    yield fork(addCaseSaga);
    yield fork(getLayoutInfo);
}